<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M5.08756 9.12798C3.63156 9.12798 2.90356 8.04998 2.90356 6.57998C2.90356 5.10998 3.63156 4.03198 5.08756 4.03198C6.52956 4.03198 7.25757 5.10998 7.25757 6.57998C7.25757 8.04998 6.54356 9.12798 5.08756 9.12798ZM4.00956 14V13.86L10.6456 4.19998H12.0316V4.33998L5.42356 14H4.00956ZM5.08756 8.02198C5.75956 8.02198 6.06756 7.53198 6.06756 6.57998C6.06756 5.62798 5.75956 5.13798 5.08756 5.13798C4.41556 5.13798 4.09356 5.62798 4.09356 6.57998C4.09356 7.53198 4.41556 8.02198 5.08756 8.02198ZM11.0236 14.126C9.56756 14.126 8.83957 13.048 8.83957 11.578C8.83957 10.108 9.56756 9.02998 11.0236 9.02998C12.4656 9.02998 13.2076 10.108 13.2076 11.578C13.2076 13.048 12.4796 14.126 11.0236 14.126ZM11.0236 13.02C11.6956 13.02 12.0036 12.53 12.0036 11.578C12.0036 10.626 11.6956 10.136 11.0236 10.136C10.3516 10.136 10.0436 10.626 10.0436 11.578C10.0436 12.53 10.3516 13.02 11.0236 13.02Z"
    />
  </svg>
</template>
